export function initRegisterModalScripts(parent) {

    const registerForm = $(parent).find(".auth-reg form")
    const errorBlock = $(parent).find(".reg-errors")
    const strContent = `
					<div class="modal-alert-with-icon">
						<div class="title">Вы успешно зарегистрированы!</div>
                        <p></p>
						<button class="blue-btn btn-close">Закрыть</button>
					</div>`;

    jQuery.validator.addMethod(
        "lettersonly",
        function (value, element) {
            return this.optional(element) || /^[a-zа-яё\s]+$/i.test(value);
        },
        "Только буквы"
    );
    jQuery.validator.addMethod("isEmailValid", function (value, element) {
        var re =
            /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(value);
    })
    jQuery.validator.addMethod("isValidPhone", function (value, element) {
        const re = /^[\d\+][\d\(\)\ -]{4,14}\d$/;
        return re.test(value);
    })
    jQuery.validator.addMethod("isEqual", function (value, element, param) {
        return this.optional(element) || value === $(param).val();
    }, "Пароли должны совпадать");


    if ($('#g-recaptcha-modal').length) {
        grecaptcha.render('g-recaptcha-modal', {
            'sitekey': '6LctEsogAAAAABaBNK6GZj8y3T25tm-lkd2AGWdw'
        });
    }

    $("#REGISTER_PERSONAL_PHONE").mask("+7 999 999-99-99", { autoclear: false });

    $(parent).find('.auth-reg .input-ui.password .svg-not-see, .auth-reg .input-ui.password .svg-see').each(function (i, el) {

        $(el).on("click", function () {
            var parent = $(el).parent().parent();
            var input = parent.find('input');

            parent.toggleClass('open-for-see');

            if (parent.hasClass('open-for-see')) {
                input.attr('type', 'text');
            } else {
                input.attr('type', 'password');
            }
        })
    })

    registerForm.validate({

        submitHandler: function (form) {

            const formData = {
                NAME: $(form).find("#REGISTER_NAME").val(),
                LAST_NAME: $(form).find("#REGISTER_LAST_NAME").val(),
                SECOND_NAME: $(form).find("#REGISTER_SECOND_NAME").val(),
                REGISTER_PERSONAL_PHONE: $(form).find("#REGISTER_PERSONAL_PHONE").val(),
                LOGIN: $(form).find("#REGISTER_EMAIL").val(),
                PASSWORD: $(form).find("#PASSWORD").val(),
                sessid: $(form).find("input[name='sessid']").val(),
                'g-recaptcha-response' : grecaptcha.getResponse(),
            };

            $.ajax({
                type: "POST",
                url: "/local/ajax/addNewUser.php",
                data: formData,
                dataType: "json",
                encode: true,
            }).done(function (data) {
                if (data.success === "Y") {
                    const regModal = App.components.Modal.getModalById("authModal")
                    regModal.setContent(strContent)
                    regModal.setupCloseBtnEvent()
                    $(form).find(".g-recaptcha").hide();
                } else {
                    errorBlock.text(data.error)
                    console.log(data.error)
                    grecaptcha.reset();
                }
            }).fail(function (res, exception) {
                console.log(res);

                grecaptcha.reset();
            });
        },
        rules: {
            "REGISTER[EMAIL]": {
                required: true,
                isEmailValid: true,
                email: true,
            },
            "REGISTER[NAME]": {
                required: true,
                lettersonly: true,
                minlength: 2,
            },
            "REGISTER[LAST_NAME]": {
                required: true,
                lettersonly: true,
                minlength: 2,
            },
            "REGISTER[SECOND_NAME]": {
                required: true,
                lettersonly: true,
                minlength: 2,
            },
            "REGISTER[PERSONAL_PHONE]": {
                required: true,
                isValidPhone: true
            },
            "REGISTER[PASSWORD]": {
                required: true,
                minlength: 10,
            },
            "REGISTER[CONFIRM_PASSWORD]": {
                required: true,
                minlength: 10,
                equalTo: "#PASSWORD"
            },
        },
        errorPlacement: function(error, element) {
            if(element.attr("type") === "password") {
                error.appendTo( element.parent().parent());
            } else {
                error.appendTo( element.parent());
            }
        },
        messages: {
            "REGISTER[PERSONAL_PHONE]": {
                required: "Обязательное поле",
                isValidPhone: "Введите корректный номер телефона"
            },
            "REGISTER[PASSWORD]": {
                required: "Обязательное поле",
                minlength: "Пожалуйста, введите не менее 10 символов"
            },
            "REGISTER[CONFIRM_PASSWORD]": {
                required: "Обязательное поле",
                minlength: "Пожалуйста, введите не менее 10 символов",
                equalTo: "Пароли не совпадают"
            },
            "REGISTER[NAME]": {
                required: "Обязательное поле",
                lettersonly: "Поле должно содержать только буквы",
                minlength: "Пожалуйста, введите не менее 2 букв"
            },
            "REGISTER[SECOND_NAME]": {
                required: "Обязательное поле",
                lettersonly: "Поле должно содержать только буквы",
                minlength: "Пожалуйста, введите не менее 2 букв"
            },
            "REGISTER[LAST_NAME]": {
                required: "Обязательное поле",
                lettersonly: "Поле должно содержать только буквы",
                minlength: "Пожалуйста, введите не менее 2 букв"
            },
            "REGISTER[EMAIL]": {
                required:
                    "Обязательно заполнить. Должен быть ваш действующий адрес эл.почты.",
                email:
                    "Ваш адрес электронной почты должен быть в формате example@domain.ru",
                isEmailValid:
                    "Ваш адрес электронной почты должен быть в формате example@domain.ru",
            },
        },
        focusInvalid: true
    })

};
